<template>
    <div id="Statistics">
        <h1 class="h1 center">海洋廢棄物統計</h1>
        <suspense>
            <template #default>
                <StatisticsMap></StatisticsMap>
            </template>
            <template #fallback>
                <div>Loading...</div>
            </template>
        </suspense>
    </div>
</template>
<script>
import { StatisticsMap } from '@/components/ch'
export default {
    name: 'Statistics',
    components: { StatisticsMap },
}
</script>
<style lang="scss" scoped>
#Statistics {
    padding-bottom: 50px;
}
</style>
